import React from 'react'
import cbModal from '../../../Modal/Modal';
import UploadModal from '../UploadModal'
import { UploadAssetModalProps, CreateFolder, GetUsers, GetFolders, UploadFiles } from '../../types';
import {
  getUsers as getUsersUsingSdk,
  createFolder as createFolderUsingSdk,
  getFolders as getFoldersUsingSdk,
} from '../../commons/request';

type OpenUploadAssetModalUseSdk = {
  /**
   * App SDK (for extensions)
   */
  sdk: any;
  getFolders?: never;
  createFolder?: never;
  getUsers?: never;
  upload?: never;
}

type OpenUploadAssetModalUsingGetters = {
  /**
   * Async function to fetch folders
   */
  getFolders: GetFolders;
  /**
   * Async function to create a folder
   */
  createFolder: CreateFolder;
  /**
   * Async function to fetch assets
   */
  getUsers: GetUsers;
  /**
   * Async function to upload an asset
   */
  upload: UploadFiles;
  sdk?: never;
}

type OpenUploadAssetModalOptions = Omit<UploadAssetModalProps, "closeModal" | "upload" | "getFolders" | "createFolder" | "getUsers">
  & (OpenUploadAssetModalUseSdk | OpenUploadAssetModalUsingGetters)

export const openUploadAssetModal = (args: OpenUploadAssetModalOptions) => {
  const contentstackSDK = args.sdk;
  const uploadUsingSdk = contentstackSDK?.stack.Asset.uploadAsset;

  // use fetch functions or sdk  
  const getFolders = args.getFolders ?? (contentstackSDK && getFoldersUsingSdk);
  const getUsers = args.getUsers ?? (contentstackSDK && getUsersUsingSdk);
  const createFolder = args.createFolder ?? (contentstackSDK && createFolderUsingSdk);
  const upload: UploadFiles = (fileArg) => {
    if (args.upload) {
      return args.upload(fileArg)
    } else {
      return uploadUsingSdk(fileArg?.files, fileArg?.options)
    }
  }

  // if any function is still missing, throw error
  const gettersMissing = !getFolders || !getUsers || !createFolder || !upload;
  if (gettersMissing) {
    throw new Error(
      `openUploadAssetModal (required props missing): "sdk", functions - "getFolders", "getUsers", "createFolder" and "upload". 
      Needs "sdk" or all functions. Optionally, only some functions can also be provided along WITH sdk.`
    )
  }

  if ("sdk" in args) {
    window.contentstackSDK = contentstackSDK
    window.postRobot = contentstackSDK.postRobot
  }

  if (args?.multiple === true || (typeof args?.multiple === 'object' && args.multiple.max > 10)) {
    args.multiple = { max: 10 }
  }

  cbModal({
    component: (props) =>
      <UploadModal
        {...args}
        {...props}
        getFolders={getFolders}
        getUsers={getUsers}
        createFolder={createFolder}
        upload={upload}
        closeModal={() => {
          props.closeModal()
          if (args.onCancel) {
            args.onCancel()
          }
        }}
      />,
    modalProps: {
      size: 'max',
      customClass: 'reference__modal',
    },
  })
}